module["exports"] = [
  "#{street_prefix} #{Name.first_name} #{Name.last_name}",
  "N#",
  "N##",
  "N###",
  "N###-#"
];
